import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__